package com.appsyde.shared.presentation.style.animations

import org.jetbrains.compose.web.css.*

object AppStylesAnimations : StyleSheet() {

    val spin by keyframes {
        from { property("transform", "rotate(0deg)") }
        to { property("transform", "rotate(360deg)") }
    }

    val appsydeProgress by keyframes {
        from { property("transform", "translate3d(-100%,0,0)") }
        to { property("transform", "translate3d(220%,0,0)") }
    }

    val shake by keyframes {
        0.percent { property("transform", "translateX(0)") }
        25.percent { property("transform", "translateX(-3px)") }
        50.percent { property("transform", "translateX(3px)") }
        75.percent { property("transform", "translateX(-2px)") }
        100.percent { property("transform", "translateX(0)") }
    }

    val thinkingPulse by keyframes {
        0.percent { property("opacity", "0.25") }
        40.percent { property("opacity", "0.95") }
        100.percent { property("opacity", "0.25") }
    }

    /** Clignotement du dot « Analyse en cours » */
    val dotBlink by keyframes {
        0.percent { property("opacity", "1") }
        50.percent { property("opacity", "0.35") }
        100.percent { property("opacity", "1") }
    }

    /** Ligne fine discrète, animation lente (analyse en cours) */
    val linePulse by keyframes {
        0.percent { property("opacity", "0.35") }
        50.percent { property("opacity", "0.65") }
        100.percent { property("opacity", "0.35") }
    }

    /** Fade-in doux (ex. « Aucun ticket sélectionné » après 100 %) */
    val fadeIn by keyframes {
        from { property("opacity", "0") }
        to { property("opacity", "1") }
    }

    /** Révélation de la prochaine action (fade + slide up) quand le texte change */
    val actionReveal by keyframes {
        from {
            property("opacity", "0")
            property("transform", "translateY(8px)")
        }
        to {
            property("opacity", "1")
            property("transform", "translateY(0)")
        }
    }

    /** Conteneur pour jouer l'animation à chaque changement d'action recommandée */
    val copilotStepActionReveal by style {
        property("animation", "${actionReveal.name} 0.35s ease forwards")
    }

    /** Révélation au premier affichage des pages type gate (permissions, invitation, billing, etc.). */
    val pageReveal by style {
        property("animation", "${actionReveal.name} 0.35s ease-out forwards")
    }

    /** Shake sur zone drop quand un fichier est refusé */
    val attachmentDropShake by style {
        property("animation", "${shake.name} 0.4s ease")
    }

    /** Petit cercle de chargement infini (dans un bouton CTA) */
    val ctaSpinner by style {
        width(16.px)
        height(16.px)
        border(2.px, LineStyle.Solid, Color("rgba(255,255,255,0.4)"))
        property("border-top-color", "rgba(255,255,255,0.95)")
        borderRadius(50.percent)
        property("animation", "${spin.name} 0.75s linear infinite")
        flexShrink(0)
    }
}
